import React from 'react';
import OrganizationsTable from '../components/OrganizationTable';

export function Organizations() {
  return <OrganizationsTable />;
}
